"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SponsorIcon = SponsorIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SponsorIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.0755 1.5645C11.2664 0.876939 12.7336 0.876939 13.9245 1.5645L20.0755 5.11578C21.2664 5.80334 22 7.074 22 8.44911V15.5517C22 16.9268 21.2664 18.1974 20.0755 18.885L13.9245 22.4363C12.7336 23.1238 11.2664 23.1238 10.0755 22.4363L3.9245 18.885C2.73362 18.1974 2 16.9268 2 15.5517V8.44911C2 7.07399 2.73362 5.80334 3.9245 5.11578L10.0755 1.5645Z",
    fill: "#6236BD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 15.2122L14.9099 16.9003C15.4428 17.2096 16.0949 16.7523 15.9547 16.1739L15.1834 12.9995L17.7567 10.8608C18.2265 10.4707 17.9741 9.73094 17.357 9.68386L13.9703 9.40812L12.6451 6.40857C12.4067 5.86381 11.5933 5.86381 11.3549 6.40857L10.0297 9.40139L6.64296 9.67713C6.02591 9.72421 5.77349 10.464 6.24328 10.8541L8.81663 12.9928L8.04532 16.1672C7.90509 16.7456 8.55719 17.2029 9.09009 16.8935L12 15.2122Z",
    fill: "#FCCE2C"
  }));
}